<template>
    <Loader v-if="loading" />
    <TabView>
      <TabPanel v-for="type in types" :key="type.type_pp" :header="type.description">
        <div v-if="type.items.length">
          <DataTable :value="type.items" class="w-full" paginator :rows="50" :rowsPerPageOptions="[50,100,250,500]" :globalFilterFields="['code']">
            <Column v-for="col of type.columns" :key="col.field" :field="col.field" :header="col.header"></Column>
          </DataTable>
        </div>
        <div v-else>
          Nessun esito precheck switch out presente per questo mese
        </div>
      </TabPanel>
    </TabView>
  </template>
  
  <script>
  import {ref, onMounted, getCurrentInstance } from 'vue';
  import Loader from "@/components/Loader.vue"
  import Service from '@/services/ask-pratiche/pratiche-wizard'
  import moment from 'moment'
  var CSV = require("xlsx");
  import { useToast } from "primevue/usetoast";
     
  export default {
    components: {
      Loader,
    },
    props: {
      data_search: Date
    },
    
    setup (props) { 
      const toast = useToast();
      const loading = ref(false)
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      const service = new Service(self.$eventBus)
      const date = ref(props.data_search)
      const mesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
      const types = ref([
        {type_pp: 'ee',device:'POD', description: 'Energia', items:[], columns:[{field:'code', header:'POD'},{field:'RAG_SOC_CONTR_COMM', header:'RAGIONE SOCIALE CONTROPARTE COMMERCIALE'},{field:'EMAIL_CONTR_COMM', header:'EMAIL CONTROPARTE COMMERCIALE'},{field:'RISOLUZIONE_CONTRATTUALE_TIMOE', header:'RISOLUZIONE CONTRATTUALE TIMOE'}]},
        {type_pp: 'gas',device:'PDR', description: 'Gas', items:[], columns:[{field:'code', header:'POD'},{field:'RAGIONE_SOCIALE_CONTROPARTECOMMERCIALE', header:'RAGIONE SOCIALE CONTROPARTE COMMERCIALE'},{field:'POSTA_CERTIFICATA', header:'EMAIL CONTROPARTE COMMERCIALE'}]}
      ])

      const items = ref()
  
      onMounted(() => { 
        loading.value = true
        
        Promise.all([getEsitiPrecheck()])
        .finally(()=>{
          loading.value = false
        })
      })
  
      const getEsitiPrecheck = async (swo = true) => {
        items.value = []
        
        loading.value = true
        let data = moment(date.value).add(1, 'month').format('Y-MM')
  
        await service.getEsitiPrecheck(data,swo)
        .then((res)=>{
          Object.keys(res.items).forEach(type => {
            let index = types.value.findIndex(e => e.type_pp == type)
            if (index != -1) {
              types.value[index].items = res.items[type]
            }
          })
        })
        .finally(()=>{
          loading.value = false
        })
      }
     
      return {
        loading,
        moment,
        date,
        types,
        items
      }
    },
  }
  </script>
  
  <style scoped>
  .p-card{
    min-width: 335px !important;
  }
  .btn-red, .btn-red:hover{
    color: #ffffff;
    background: #d32f2f;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 3px;
    border: 1px solid #2196F3;
  }
  .form-file .button-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 250px;
    border: 2px dashed rgba(156, 156, 156, 0.577);
    border-radius: 5px;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  
  .form-file .allowed-format {
    font-size: 12px;
    color: rgb(186, 186, 186);
    margin-top: 2px;
  }
  
  .form-file .button-wrapper span.label {
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 250px;
    background: #ffffff;
    cursor: pointer;
    color: rgb(168, 168, 168);
    padding: 10px 2px;
    text-transform:uppercase;
    font-size:12px;
    border-radius: 3px;
    box-shadow: none;
  }
  
  .form-file .remove-file {
      color: red;
      margin-top:15px;
      cursor: pointer;
      text-align: center;
      text-transform: uppercase;
      font-size: 12px;
  }
  
  .form-file .button-wrapper span.label.active {
    color: #2196F3;
  }
  
  #uploadIV, #uploadPK {
      display: inline-block;
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
  }
  .btn-download{
    width: 173px;
  }
  </style>
  